import { ProductTypeConfig, DEFAULT_SECTIONS } from '../types';

/**
 * 1140 - Capital Certificate Protection with Coupon
 * Express
 */
export const config1140Express: ProductTypeConfig = {
  code: '1140',
  callableType: 'Express',
  name: 'Capital Certificate Protection with Coupon',
  sections: {
    ...DEFAULT_SECTIONS,
    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      enabled: true,
      props: {
        couponTrigger: true,
        couponFrequency: true,
        couponType: true,
        autocallTrigger: true,
        autocallFrequency: true,
        capitalProtectionPct: true,
      },
    },
    barrier: {
          ...DEFAULT_SECTIONS.barrier,
          enabled: false,
    },
    underlyings: {
        ...DEFAULT_SECTIONS.underlyings,
        props: {
            barrierLevel: false,
            barrierDistance: false,
        }
    }
  },
};

/**
 * 1140 - Capital Certificate Protection with Coupon
 * Fixed
 */
export const config1140Fixed: ProductTypeConfig = {
    code: '1140',
    callableType: 'Fixed',
    name: 'Capital Certificate Protection with Coupon',
    sections: {
        ...DEFAULT_SECTIONS,
        atGlance: {
            ...DEFAULT_SECTIONS.atGlance,
            enabled: true,
            props: {
                couponTrigger: true,
                couponFrequency: true,
                couponType: true,
                capitalProtectionPct: true,
                stepUp: true,
                couponMinimum: true,
                couponMaximum: true,
                strike: true,
            },
        },
        barrier: {
            ...DEFAULT_SECTIONS.barrier,
            enabled: false,
        },
        underlyings: {
            ...DEFAULT_SECTIONS.underlyings,
            enabled: false,
        }
    },
};

/**
 * 1140 - Capital Certificate Protection with Coupon
 * Floored
 */
export const config1140Floored: ProductTypeConfig = {
    code: '1140',
    callableType: 'Floored',
    name: 'Capital Certificate Protection with Coupon',
    sections: {
        ...DEFAULT_SECTIONS,
        atGlance: {
            ...DEFAULT_SECTIONS.atGlance,
            enabled: true,
            props: {
                couponTrigger: true,
                couponFrequency: true,
                couponType: true,
                capitalProtectionPct: true,
                stepUp: true,
                couponMinimum: true,
                couponMaximum: true,
                strike: true,
            },
        },
        barrier: {
            ...DEFAULT_SECTIONS.barrier,
            enabled: false,
        },
        underlyings: {
            ...DEFAULT_SECTIONS.underlyings,
            enabled: false,
        }
    },
};

/**
 * 1140 - Capital Certificate Protection with Coupon
 * Step
 */
export const config1140Step: ProductTypeConfig = {
    code: '1140',
    callableType: 'Step',
    name: 'Capital Certificate Protection with Coupon',
    sections: {
        ...DEFAULT_SECTIONS,
        atGlance: {
            ...DEFAULT_SECTIONS.atGlance,
            enabled: true,
            props: {
                couponTrigger: true,
                couponFrequency: true,
                couponType: true,
                capitalProtectionPct: true,
                stepUp: true,
                couponMinimum: true,
                couponMaximum: true,
                strike: true,
            },
        },
        barrier: {
            ...DEFAULT_SECTIONS.barrier,
            enabled: false,
        },
        underlyings: {
            ...DEFAULT_SECTIONS.underlyings,
            enabled: false,
        }
    },
};